import {Injectable} from '@angular/core';
import {AuthService} from '../../core/security/auth.service';
import {ReportsService as ReportsApiService} from '../../api/services/reports.service';
import * as _ from 'lodash';

@Injectable()
export class HuntGroupsSummaryService {

  public exportColumns: any[] = [
    {id: _.uniqueId('id_'), field: '_id', title: 'Account Number', width: 10},
    {id: _.uniqueId('id_'), field: 'name', title: 'Name', width: 10},
    {id: _.uniqueId('id_'), field: 'count', title: 'Total Calls', width: 10},
    {id: _.uniqueId('id_'), field: 'answered', title: 'Answered', width: 10},
    {id: _.uniqueId('id_'), field: 'missed', title: 'Abandoned', width: 10},
    {id: _.uniqueId('id_'), field: 'durationRingFormatted', title: 'Total Duration while Ring', width: 10},
    {id: _.uniqueId('id_'), field: 'durationHoldFormatted', title: 'Total Duration while Hold', width: 10},
    {id: _.uniqueId('id_'), field: 'durationTalkFormatted', title: 'Total Duration while Talk', width: 10},
    {id: _.uniqueId('id_'), field: 'avgDurationWaitFormatted', title: 'Average Ring Time', width: 10},
    {id: _.uniqueId('id_'), field: 'avgDurationTalkFormatted', title: 'Average Talk Time', width: 10},

  ];
  public exportAgentsColumns: any[] = [
    {id: _.uniqueId('id_'), field: '_id', title: 'Account Number', width: 10},
    {id: _.uniqueId('id_'), field: 'name', title: 'Name', width: 10},
    {id: _.uniqueId('id_'), field: 'totalAnswered', title: 'Total Answered', width: 10},
    {id: _.uniqueId('id_'), field: 'totalMissed', title: 'Calls Not Accepted', width: 10},
    // {id: _.uniqueId('id_'), field: 'totalLoggedInFormatted', title: 'Total Logged In', width: 10},
    {id: _.uniqueId('id_'), field: 'avgDurationRingFormatted', title: 'Average Ring Time', width: 10},
    {id: _.uniqueId('id_'), field: 'avgDurationTalkFormatted', title: 'Average Talk Time', width: 10}

    /*
    {id: _.uniqueId('id_'), field: 'durationRingFormatted', title: 'Total Duration while Ring', width: 10},
    {id: _.uniqueId('id_'), field: 'durationHoldFormatted', title: 'Total Duration while Hold', width: 10},
    {id: _.uniqueId('id_'), field: 'durationTalkFormatted', title: 'Total Duration while Talk', width: 10},
    {id: _.uniqueId('id_'), field: 'avgDurationWaitFormatted', title: 'Average Ring Time', width: 10},
    {id: _.uniqueId('id_'), field: 'avgDurationTalkFormatted', title: 'Average Talk Time', width: 10}
    */
  ];
  public aggregates: any[] = [
    {field: 'count', aggregate: 'sum'},
    {field: 'answered', aggregate: 'sum'},
    {field: 'durationIvr', aggregate: 'sum'},
    {field: 'durationHold', aggregate: 'sum'},
    {field: 'durationIdle', aggregate: 'sum'},
    {field: 'durationRing', aggregate: 'sum'},
    {field: 'durationTalk', aggregate: 'sum'},
  ];

  constructor(private authService: AuthService, private reportsApiService: ReportsApiService) {

  }
}
